import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-background px-4 py-20 sm:py-28" data-id="element-349" data-mp="3fzntrlbxjb1d">
      <div className="mx-auto max-w-6xl" data-id="element-350" data-mp="3fy2whny8ddzt">
        <div className="text-center" data-id="element-351" data-mp="3b0uepogzvbz3">
          <div className="flex justify-center gap-1 text-accent" aria-hidden="true" data-id="element-352" data-mp="3azt2vhs5mlgb">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} size={18} fill="currentColor" data-id="element-353" data-mp="31zmto83ho7my" data-mpi={i} />)}
          </div>
          <h2 className="mt-4 text-3xl font-semibold text-foreground sm:text-4xl" data-id="element-354" data-mp="2x09x2vmtfm76">
            What Barre Instructors Are{' '}
            <span className="italic text-primary" data-id="element-355" data-mp="2s308tjb5xgkx">Saying</span>
          </h2>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-356" data-mp="v8dn3qgaqkei">
          {testimonials.map((item, index) => <motion.figure key={item.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col rounded-xl border border-primary/20 bg-surface p-6 shadow-card sm:p-7" data-id="element-357" data-mp="qbn5gyoufgqz" data-mpi={index}>
              <div className="flex items-start justify-between" data-id="element-358" data-mp="zxha4h32wj3j">
                <div className="flex gap-0.5 text-accent" aria-label="5 out of 5 stars" data-id="element-359" data-mp="14v9alzhshdjc">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} size={14} fill="currentColor" aria-hidden="true" data-id="element-360" data-mp="q63c6dqrzrci" data-mpi={i} />)}
                </div>
                <span className="-mt-2 font-display text-6xl leading-none text-accent-soft" aria-hidden="true" data-id="element-361" data-mp="v3d4c15juh41">
                  “
                </span>
              </div>
              <blockquote className="mt-2 pb-6 font-display text-lg italic leading-8 text-foreground" data-id="element-362" data-mp="1xiis4va4tii6">
                {item.quote}
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 border-t border-primary/15 pt-5" data-id="element-363" data-mp="1sgtdz6rm4opv">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-strong text-sm font-semibold text-primary-foreground" data-id="element-364" data-mp="1oj5h3y6d0lvc">
                  {item.name.split(' ').map(part => part[0]).join('')}
                </span>
                <span className="text-sm leading-5" data-id="element-365" data-mp="14t22249zidp4">
                  <span className="block font-semibold text-foreground" data-id="element-366" data-mp="14tlbewlkjtrj">
                    {item.name}
                  </span>
                  <span className="block text-muted-foreground" data-id="element-367" data-mp="vsngd3t3ywl3">
                    {item.role} · {item.location}
                  </span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}